export enum HighlightColor {
    Yellow = 1,
    Green = 2,
    Orange = 3,
    Blue = 4,
    Pink = 5,
}
